import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// components
import CustomInput from 'components/backoffice/customInput';

const TranslationModal = ({ show, onHide, translatedItem, setTranslatedItem, handleTranslateItem }) => {
  const { t } = useTranslation(['backoffice']);
  const company = useSelector((state) => state.company);
  const languages = company.languages;

  useEffect(() => {
    if (show) {
      document.title = `${t('addTranslation')}: ${translatedItem?.text}`;
    }
    return () => {
      document.title = 'Backoffice';
    };
  }, [show, translatedItem, t]);

  const handleChange = (languageCode, value) => {
    setTranslatedItem({
      ...translatedItem,
      [`text_${languageCode}`]: value,
    });
  };

  return (
    <Modal className="modal-backoffice" show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{t('addTranslation')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {languages
          .filter((language) => language.code_iso2 !== 'es')
          .map((language) => (
            <div key={language.code_iso2}>
              <CustomInput
                label={`${t('titulo')} (${language.nombre})`}
                type="text"
                value={translatedItem[`text_${language.code_iso2}`] || ''}
                onChange={(value) => handleChange(language.code_iso2, value)}
              />
            </div>
          ))}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-intra bg-terciary-color btn btn-primary" onClick={onHide}>
          {t('cancel')}
        </Button>
        <Button className="btn-intra bg-primary-color btn btn-primary" onClick={handleTranslateItem}>
          {t('save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

TranslationModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  translatedItem: PropTypes.object,
  setTranslatedItem: PropTypes.func,
  handleTranslateItem: PropTypes.func,
};

export default TranslationModal;
